module.exports = __webpack_public_path__ + "1623fdaed51f835e752f10186a27c3d4.png";